// @ts-expect-error untyped dependency
import { useEmbedContext } from '../hooks/useEmbedContext';
import { getIsCustomer } from '../selectors/auth';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { getDownloadedAssetsUrl } from 'marketplace-ui-assets-core/utils/urls';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import StorefrontHeader from 'marketplace-ui-common/storefront/components/StorefrontHeader';
import { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import StorefrontSearchBar from '../components/storefront/search/StorefrontSearchBar';
import { useOfferingType } from '../context/OfferingTypeContext';
import { getIsPublicApp } from '../selectors/app';
import { getAssetProviderSignupUrl, getTemplatesHomePageRoute } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontPage({
  children,
  navigation,
  sidebar,
  renderedBreadcrumbs
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  const location = useLocation();
  const {
    pathname: currentPathname
  } = location;
  const [isSticky, setIsSticky] = useState(false);
  const onStickyChange = useCallback(evt => {
    setIsSticky(evt.target.value);
  }, []);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StorefrontHeader, {
      collapsedTitle: /*#__PURE__*/_jsx(RouterLink, {
        to: getTemplatesHomePageRoute(),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.header.collapsedTitle"
        })
      }),
      color: "white",
      compact: isEmbedded,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.subtitle"
      }),
      testId: "storefront-header",
      title: /*#__PURE__*/_jsx(RouterLink, {
        to: getTemplatesHomePageRoute(),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(HeadingComponent, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.header.title"
          })
        })
      }),
      renderedButtonRow: /*#__PURE__*/_jsx(HeaderButtonRow, {}),
      onStickyChange: onStickyChange,
      use: isEmbedded ? 'collapsed' : 'default',
      renderBreadcrumbsInTitle: true,
      renderedBreadcrumbs: renderedBreadcrumbs,
      children: /*#__PURE__*/_jsx(StorefrontSearchBar, {
        isSticky: isSticky || isEmbedded
      })
    }, `storefront-header-${currentPathname}`), navigation, /*#__PURE__*/_jsx(MainSection, {
      responsive: true,
      color: "light",
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsxs(Grid, {
          children: [/*#__PURE__*/_jsx(GridItem, {
            size: {
              lg: 3
            },
            children: sidebar
          }), /*#__PURE__*/_jsx(GridItem, {
            size: {
              xs: 12,
              lg: 9
            },
            children: children
          })]
        })
      })
    })]
  });
}
function HeadingComponent({
  children
}) {
  const {
    pathname
  } = useLocation();
  const textColor = 'text-core-default';
  if (pathname === '/') {
    return /*#__PURE__*/_jsx(Text, {
      as: "h1",
      color: textColor,
      marginBlockEnd: "400",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    typography: "heading-600",
    color: textColor,
    marginBlockEnd: "400",
    children: children
  });
}
function HeaderButtonRow() {
  const offeringType = useOfferingType();
  const isPublicApp = useSelector(getIsPublicApp);
  const isCustomer = useSelector(getIsCustomer);
  if (isPublicApp) return null;
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(Button, {
      "data-selenium-id": "manage-apps-button",
      href: getDownloadedAssetsUrl(!isCustomer, offeringType),
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.buttons.manage"
      })
    }), /*#__PURE__*/_jsx(Button, {
      external: true,
      href: getAssetProviderSignupUrl(),
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.header.buttons.build"
      })
    })]
  });
}